module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', {
    staticClass: "login-page"
  }, [_c('h2', {
    staticClass: "card-title center-align"
  }, [_vm._v("Logowanie")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle center-align"
  }, [_vm._v("Zaloguj się, aby sprawdzić stan środków na Twoim koncie")]), _vm._v(" "), _c('div', {
    staticClass: "social-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("Zaloguj się za pomocą:")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12 m6 offset-m3"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-light red lighten-1",
    attrs: {
      "id": "google"
    },
    on: {
      "click": function($event) {
        return _vm.authorize('google_oauth2')
      }
    }
  }, [_c('i', {
    staticClass: "mfind-icon mfind-icon-google_white left"
  }), _vm._v(" "), _c('span', [_vm._v("Google")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "email-auth-container"
  }, [_c('div', {
    staticClass: "line-through-header center-align"
  }, [_c('span', [_vm._v("lub przy użyciu "), _c('br'), _vm._v("adresu email:")])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "POST"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitLogin()
      }
    }
  }, [(_vm.data.errors) ? _c('div', {
    staticClass: "center-align validation-errors"
  }, [(_vm.data.errors['message']) ? _c('span', {
    staticClass: "red-text"
  }, [_vm._v(_vm._s(_vm.data.errors['message'].join(', ')))]) : _c('span', {
    staticClass: "red-text"
  }, [_vm._v("Nieprawidłowy login lub hasło, spróbuj ponownie")])]) : _vm._e(), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "email",
      "name": "email",
      "label": "Adres e-mail",
      "required": "true"
    },
    model: {
      value: (_vm.data.email),
      callback: function($$v) {
        _vm.$set(_vm.data, "email", $$v)
      },
      expression: "data.email"
    }
  }), _vm._v(" "), _c('input-field', {
    attrs: {
      "type": "password",
      "name": "password",
      "label": "Hasło",
      "required": "true"
    },
    model: {
      value: (_vm.data.password),
      callback: function($$v) {
        _vm.$set(_vm.data, "password", $$v)
      },
      expression: "data.password"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-large z-depth-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Zaloguj się")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n    Nie pamiętasz "), _c('router-link', {
    attrs: {
      "to": {
        name: 'passForgot'
      }
    }
  }, [_vm._v("hasła")]), _vm._v("?"), _c('br'), _vm._v("\n    Nie masz konta? "), _c('router-link', {
    attrs: {
      "to": {
        name: 'register'
      }
    }
  }, [_vm._v("Zarejestruj się")]), _vm._v(" za darmo!\n  ")], 1), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.data.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bfb4926","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login.vue
// module id = 387
// module chunks = 0